var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st00000{fill:#5286FA;}\r\n\t.st00001{fill:#EFC27B;}\r\n\t.st00002{fill:#A4E276;}\r\n\t.st00003{fill:#ECB45C;}\r\n\t.st00004{fill:#64C37D;}\r\n\t.st00005{fill:#424EDE;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st00000",
    d: "M276.3,328l-59.6,59.6l-5.2,5.2c-4.1,4.1-6.4,9.6-6.4,15.4v1.2v21.8v42.9c0,12,9.8,21.8,21.8,21.8h65.9 c5.8,0,11.3-2.3,15.4-6.4l181.3-181.3c8.5-8.5,8.5-22.3,0-30.9l-65.9-65.9c-4.1-4.1-9.6-6.4-15.4-6.4c-5.8,0-11.3,2.3-15.4,6.4 l-85.6,85.6l-15.5,15.5L276.3,328z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st00001",
    d: "M92,107.3c0,50.3,40.9,91.3,91.3,91.3s91.3-40.9,91.3-91.3S233.6,16,183.3,16S92,56.9,92,107.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st00002",
    d: "M37.8,431.3h167.3v-21.8v-1.2c0-5.8,2.3-11.3,6.4-15.4l5.2-5.2l59.6-59.6l15.5-15.5l15.5-15.5 c-31.5-34.8-76.2-54.9-123.9-54.9C91,242.2,16,317.2,16,409.5C16,421.5,25.8,431.3,37.8,431.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st00003",
    d: "M92,107.3c0,50.3,40.9,91.3,91.3,91.3l0,0V16l0,0C132.9,16,92,56.9,92,107.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st00004",
    d: "M183.3,242.2C91,242.2,16,317.2,16,409.5c0,12,9.8,21.8,21.8,21.8h145.5L183.3,242.2L183.3,242.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st00005",
    d: "M423.7,211.5c-4.1-4.1-9.6-6.4-15.4-6.4c-5.8,0-11.3,2.3-15.4,6.4l-85.6,85.6l-15.5,15.5L276.3,328l-59.6,59.6 l-5.2,5.2c-4.1,4.1-6.4,9.6-6.4,15.4v1.2v21.8v42.9c0,6.3,2.7,11.9,6.9,15.9L457.2,245L423.7,211.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/my-profile.79f8c5a9b762e5c29137ca7493eb375e.svg";
export { ForwardRef as ReactComponent };